var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 0H11.4001V4.79999H6.6001V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.826 3.77401L14.226 0.17401C14.1699 0.118401 14.1034 0.074406 14.0303 0.0445472C13.9572 0.0146885 13.879 -0.000446507 13.8 1.00286e-05H12.6V4.80001C12.6 5.11827 12.4736 5.42349 12.2485 5.64853C12.0235 5.87358 11.7182 6 11.4 6H6.59999C6.28173 6 5.97651 5.87358 5.75147 5.64853C5.52642 5.42349 5.39999 5.11827 5.39999 4.80001V1.00286e-05H1.8C1.32261 1.00286e-05 0.864772 0.189652 0.527207 0.527217C0.189642 0.864782 0 1.32262 0 1.80001V16.2C0 16.6774 0.189642 17.1352 0.527207 17.4728C0.864772 17.8104 1.32261 18 1.8 18H3V12.6C3 12.1226 3.18964 11.6648 3.5272 11.3272C3.86477 10.9896 4.32261 10.8 4.8 10.8H13.2C13.6774 10.8 14.1352 10.9896 14.4728 11.3272C14.8103 11.6648 15 12.1226 15 12.6V18H16.2C16.6774 18 17.1352 17.8104 17.4728 17.4728C17.8103 17.1352 18 16.6774 18 16.2V4.20001C18.0004 4.12104 17.9853 4.04276 17.9554 3.96966C17.9256 3.89656 17.8816 3.83007 17.826 3.77401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 12H4.80019C4.64106 12 4.48845 12.0632 4.37593 12.1757C4.26341 12.2883 4.2002 12.4409 4.2002 12.6V18H13.8002V12.6C13.8002 12.4409 13.737 12.2883 13.6244 12.1757C13.5119 12.0632 13.3593 12 13.2002 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/IconSave.a7efd2a3a320f9b1683704ef11f1fb7a.svg";
export { ForwardRef as ReactComponent };